import axios from "axios";
import BASE_URL from "../../config";




const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`
  };
};

export const getGenders = async () => {
  const response = await axios.get(`${BASE_URL}/api/Gender/get`,
    {
      headers: getAuthHeader(),
    }
  );
  return response.data;
     
   
  } 



